/* INTEGY V520 — progressive, timeout-safe Recently Viewed owner.
   The first responsive set renders from cache immediately and hydrates before the
   background history. No Flickity, no layout polling, no image resize loops. */
(function () {
  'use strict';

  if (window.IntegyV520RecentlyViewed) return;

  var root = document.documentElement;
  var MAX_ITEMS = 30;
  var INITIAL_VISIBLE_DESKTOP = 12;
  var INITIAL_VISIBLE_MOBILE = 4;
  var MAX_AGE = 30 * 24 * 60 * 60;
  var CARD_TIMEOUT = 4600;
  var PRIMARY_CONCURRENCY = 4;
  var BACKGROUND_CONCURRENCY = 3;
  var instances = [];

  function one(selector, scope) {
    try { return (scope || document).querySelector(selector); }
    catch (error) { return null; }
  }

  function initialVisibleCount() {
    try {
      return window.matchMedia && window.matchMedia('(max-width: 767px)').matches
        ? INITIAL_VISIBLE_MOBILE
        : INITIAL_VISIBLE_DESKTOP;
    } catch (error) {
      return INITIAL_VISIBLE_DESKTOP;
    }
  }

  function all(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }
    catch (error) { return []; }
  }

  function readJson(script) {
    if (!script) return null;
    try { return JSON.parse(script.textContent || '{}'); }
    catch (error) { return null; }
  }

  function safeParse(value, fallback) {
    try { return value ? JSON.parse(value) : fallback; }
    catch (error) { return fallback; }
  }

  function storageKey(data) {
    var currency = String(data && data.currency || 'USD');
    var rootUrl = String(window.Theme && Theme.routes && Theme.routes.root_url || '/');
    var business = root.hasAttribute('data-integy-b2b');
    if (business) return 'pxu-recentlyViewed-v771-b2b-' + currency + '-' + rootUrl + '-' + (root.getAttribute('data-integy-b2b-location') || 'unselected');
    return 'pxu-recentlyViewed-' + currency + '-' + rootUrl;
  }

  function readHistory(key) {
    try { return safeParse(localStorage.getItem(key), []); } catch (error) { return []; }
  }
  function writeHistory(key, items) {
    try { localStorage.setItem(key, JSON.stringify(items)); } catch (error) {}
  }
  function readCards(key) {
    if (root.hasAttribute('data-integy-b2b')) return {};
    try { return safeParse(sessionStorage.getItem(key), {}); } catch (error) { return {}; }
  }
  function writeCards(key, cards) {
    if (root.hasAttribute('data-integy-b2b')) return;
    try { sessionStorage.setItem(key, JSON.stringify(cards)); } catch (error) {}
  }

  function trimHistory(items) {
    var now = Math.floor(Date.now() / 1000);
    var minimum = now - MAX_AGE;
    var seen = Object.create(null);
    var clean = [];
    (Array.isArray(items) ? items : []).forEach(function (item) {
      var handle = String(item && item.handle || '').trim();
      var timestamp = Number(item && item.timestamp || 0);
      if (!handle || timestamp <= minimum || seen[handle]) return;
      seen[handle] = true;
      clean.push({ handle: handle, timestamp: timestamp });
    });
    clean.sort(function (left, right) { return left.timestamp - right.timestamp; });
    return clean.length > MAX_ITEMS ? clean.slice(clean.length - MAX_ITEMS) : clean;
  }

  function timeSince(timestamp, time) {
    var now = Math.round(Date.now() / 1000);
    var seconds = Math.max(0, now - Number(timestamp || now));
    var language = document.documentElement.lang || 'en';
    if (seconds < 60) {
      var secondsAgo = Math.max(1, Math.floor(seconds));
      return secondsAgo + ' ' + (secondsAgo === 1 ? time.second : time.seconds) + ' ' + time.ago;
    }
    if (seconds < 3600) {
      var minutesAgo = Math.floor(seconds / 60);
      return minutesAgo + ' ' + (minutesAgo === 1 ? time.minute : time.minutes) + ' ' + time.ago;
    }
    if (seconds <= 86400) {
      var hoursAgo = Math.floor(seconds / 3600);
      return hoursAgo + ' ' + (hoursAgo === 1 ? time.hour : time.hours) + ' ' + time.ago;
    }
    var date = new Date(Number(timestamp) * 1000);
    var current = new Date();
    var label = date.toLocaleDateString(language, { month: 'long', day: 'numeric' });
    if (date.getFullYear() !== current.getFullYear()) label += ', ' + date.getFullYear();
    return label;
  }

  function clearInlineGeometry(node) {
    if (!node || !node.style) return;
    ['width','min-width','max-width','height','min-height','max-height','left','right','top','bottom','transform','position','flex','flex-basis','margin-right']
      .forEach(function (property) { node.style.removeProperty(property); });
  }

  function normalizeCard(card, item, data) {
    if (!card) return;
    card.classList.remove('integy-v507-recent-card','integy-v514-recent-card','integy-v464-single-recent','integy-v464-recent-empty');
    card.classList.add('integy-v520-recent-card');
    clearInlineGeometry(card);
    all('.productitem,.productitem__container,.productitem__image-container,.productitem--image-link,.productitem--image,.productitem--info,.productitem--title,.productitem--title a,.productitem--price,.productitem__stock-level,.integy-product-card-sku,.product-recently-viewed-card-time', card)
      .forEach(clearInlineGeometry);
    all('.integy-v464-single-recent,.integy-v464-recent-empty,.integy-v507-recent-card,.integy-v514-recent-card', card).forEach(function (node) {
      node.classList.remove('integy-v464-single-recent','integy-v464-recent-empty','integy-v507-recent-card','integy-v514-recent-card');
    });
    all('.productitem--image-alternate', card).forEach(function (image) {
      image.hidden = true;
      image.setAttribute('aria-hidden', 'true');
      image.setAttribute('tabindex', '-1');
    });
    var timeNode = one('.product-recently-viewed-card-time[data-product-handle]', card);
    if (timeNode) {
      var remove = one('[data-remove-recently-viewed]', timeNode);
      Array.prototype.slice.call(timeNode.childNodes).forEach(function (node) {
        if (node !== remove) node.remove();
      });
      timeNode.insertBefore(document.createTextNode(timeSince(item.timestamp, data.time) + ' '), remove || null);
    }
  }

  function validCardMarkup(markup) {
    if (!markup || typeof markup !== 'string') return false;
    try { return !!new DOMParser().parseFromString(markup, 'text/html').querySelector('.productgrid--item'); }
    catch (error) { return false; }
  }

  function cardUrl(handle) {
    var base = String(window.Theme && Theme.routes && Theme.routes.all_products_collection_url || '/collections/all').replace(/\/$/, '');
    return base + '/products/' + encodeURIComponent(handle) + '?view=recently-viewed';
  }

  function fetchCard(handle) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (controller) controller.abort(); }, CARD_TIMEOUT);
    return fetch(cardUrl(handle), {
      credentials: 'same-origin',
      cache: root.hasAttribute('data-integy-b2b') ? 'no-store' : 'force-cache',
      headers: { Accept: 'text/html' },
      signal: controller && controller.signal
    }).then(function (response) {
      if (response.status === 404 || response.status === 410) return { markup: '', invalid: true };
      if (!response.ok) throw new Error('Recently viewed card request failed');
      return response.text();
    }).then(function (markup) {
      if (markup && typeof markup === 'object') return markup;
      return { markup: validCardMarkup(markup) ? markup : '', invalid: false };
    }).catch(function () { return { markup: '', invalid: false }; }).then(function (result) {
      window.clearTimeout(timer);
      return result;
    });
  }

  function watchResponsiveImages(section) {
    try { section.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true })); } catch (error) {}
  }

  function setCount(section, count) {
    var container = one('[data-recently-viewed-container]', section);
    if (!container) return;
    ['0','1','2','3plus'].forEach(function (suffix) { container.classList.remove('integy-v520-recent-count-' + suffix); });
    var suffix = count === 0 ? '0' : count === 1 ? '1' : count === 2 ? '2' : '3plus';
    container.classList.add('integy-v520-recent-count-' + suffix);
    container.setAttribute('data-integy-v520-recent-count', String(count));
    var hasCards = count > 0;
    section.hidden = !hasCards;
    section.classList.toggle('hide', !hasCards);
    section.setAttribute('aria-hidden', hasCards ? 'false' : 'true');
    var clear = one('[data-clear-recently-viewed]', section);
    if (clear) {
      clear.hidden = !hasCards;
      clear.setAttribute('aria-hidden', hasCards ? 'false' : 'true');
    }
  }

  function RecentlyViewed(section, script, data) {
    this.section = section;
    this.script = script;
    this.data = data || {};
    this.key = storageKey(this.data);
    this.container = one('[data-recently-viewed-container]', section);
    this.cardSettings = this.data.product_card_settings || {};
    this.history = [];
    this.cards = {};
    this.expanded = false;
    this.generation = 0;
    this.renderFrame = 0;
    this.cacheTimer = 0;
    this.backgroundStarted = false;
    this.boundClick = this.onClick.bind(this);
  }

  RecentlyViewed.prototype.loadState = function () {
    this.history = trimHistory(readHistory(this.key));
    var current = this.data.recently_viewed_info;
    if (current && current.handle) {
      var currentHandle = String(current.handle);
      this.history = this.history.filter(function (item) { return item.handle !== currentHandle; });
      this.history.push({ handle: currentHandle, timestamp: Math.round(Date.now() / 1000) });
      this.history = trimHistory(this.history);
    }
    writeHistory(this.key, this.history);
    this.cards = readCards(this.key);
    var cachedSettings = this.cards.cardSettings || null;
    if (!cachedSettings || JSON.stringify(cachedSettings) !== JSON.stringify(this.cardSettings)) {
      this.cards = { cardSettings: this.cardSettings };
      writeCards(this.key, this.cards);
    }
  };

  RecentlyViewed.prototype.scheduleCacheWrite = function () {
    var self = this;
    if (this.cacheTimer) return;
    this.cacheTimer = window.setTimeout(function () {
      self.cacheTimer = 0;
      writeCards(self.key, self.cards);
    }, 80);
  };

  RecentlyViewed.prototype.scheduleRender = function () {
    var self = this;
    if (this.renderFrame) return;
    this.renderFrame = window.requestAnimationFrame(function () {
      self.renderFrame = 0;
      self.render();
    });
  };

  RecentlyViewed.prototype.fetchItems = function (items, concurrency, generation) {
    var self = this;
    var missing = (items || []).filter(function (item) { return !validCardMarkup(self.cards[item.handle]); });
    var cursor = 0;
    var workers = [];
    var workerCount = Math.min(concurrency, missing.length);
    function worker() {
      if (cursor >= missing.length || generation !== self.generation) return Promise.resolve();
      var item = missing[cursor++];
      return fetchCard(item.handle).then(function (result) {
        if (generation !== self.generation) return;
        if (result.markup) self.cards[item.handle] = result.markup;
        if (result.invalid) {
          self.history = self.history.filter(function (historyItem) { return historyItem.handle !== item.handle; });
          delete self.cards[item.handle];
          writeHistory(self.key, self.history);
        }
        self.scheduleCacheWrite();
        self.scheduleRender();
      }).then(worker);
    }
    for (var i = 0; i < workerCount; i += 1) workers.push(worker());
    return Promise.all(workers);
  };

  RecentlyViewed.prototype.render = function () {
    var self = this;
    if (!this.container) return;
    this.section.classList.remove('integy-v464-single-recent','integy-v464-recent-empty','integy-v507-recently-viewed','integy-v514-recently-viewed');
    this.container.innerHTML = '';
    this.container.className = this.container.className
      .replace(/\bintegy-v464-single-recent\b/g, '')
      .replace(/\bintegy-v464-recent-empty\b/g, '')
      .replace(/\bintegy-v507-recent-grid\b/g, '')
      .replace(/\bintegy-v507-native-grid\b/g, '')
      .replace(/\bintegy-v514-recent-grid\b/g, '')
      .replace(/\bintegy-v514-native-grid\b/g, '');
    this.container.classList.add('integy-v520-recent-grid', 'integy-v520-native-grid');

    var ordered = this.history.slice().reverse();
    var available = ordered.filter(function (item) { return validCardMarkup(self.cards[item.handle]); });
    var initialVisible = initialVisibleCount();
    var visibleItems = this.expanded ? available : available.slice(0, initialVisible);
    var rendered = 0;
    visibleItems.forEach(function (item) {
      var template = document.createElement('template');
      template.innerHTML = self.cards[item.handle].trim();
      var card = one('[data-recently-viewed-card],.product-recently-viewed-card', template.content);
      if (!card) return;
      normalizeCard(card, item, self.data);
      self.container.appendChild(template.content);
      rendered += 1;
    });

    var oldStatus = one('[data-integy-v520-recent-status]', this.section);
    if (oldStatus) oldStatus.remove();
    var oldToggle = one('[data-integy-v520-recent-more]', this.section);
    if (oldToggle) oldToggle.remove();

    var loading = this.section.getAttribute('data-integy-v520-recent-loading') === 'true';
    if (!rendered && loading && ordered.length) {
      var status = document.createElement('div');
      status.className = 'integy-v520-recent-status';
      status.setAttribute('data-integy-v520-recent-status', 'true');
      status.setAttribute('role', 'status');
      status.textContent = 'Loading recently viewed items…';
      this.container.insertAdjacentElement('afterend', status);
    }

    if (available.length > initialVisible) {
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'integy-v520-recent-more';
      toggle.setAttribute('data-integy-v520-recent-more', 'true');
      toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
      toggle.textContent = this.expanded ? 'Show fewer recently viewed items' : 'Show ' + (available.length - initialVisible) + ' more recently viewed items';
      this.container.insertAdjacentElement('afterend', toggle);
    } else if (loading && available.length >= initialVisible && ordered.length > available.length) {
      var loadingMore = document.createElement('div');
      loadingMore.className = 'integy-v520-recent-status';
      loadingMore.setAttribute('data-integy-v520-recent-status', 'true');
      loadingMore.setAttribute('role', 'status');
      loadingMore.textContent = 'Loading more recently viewed items…';
      this.container.insertAdjacentElement('afterend', loadingMore);
    }

    setCount(this.section, rendered);
    watchResponsiveImages(this.section);
  };

  RecentlyViewed.prototype.startBackground = function (ordered, generation) {
    var self = this;
    var initialVisible = initialVisibleCount();
    if (this.backgroundStarted || ordered.length <= initialVisible) {
      this.section.removeAttribute('data-integy-v520-recent-loading');
      this.render();
      return Promise.resolve();
    }
    this.backgroundStarted = true;
    return this.fetchItems(ordered.slice(initialVisible), BACKGROUND_CONCURRENCY, generation).then(function () {
      if (generation !== self.generation) return;
      self.section.removeAttribute('data-integy-v520-recent-loading');
      self.render();
    });
  };

  RecentlyViewed.prototype.hydrate = function () {
    var self = this;
    var generation = ++this.generation;
    var ordered = this.history.slice().reverse();
    var initialVisible = initialVisibleCount();
    this.backgroundStarted = false;
    this.section.setAttribute('data-integy-v520-recent-loading', ordered.length ? 'true' : 'false');
    this.render();
    return this.fetchItems(ordered.slice(0, initialVisible), PRIMARY_CONCURRENCY, generation).then(function () {
      if (generation !== self.generation) return;
      self.render();
      return self.startBackground(ordered, generation);
    });
  };

  RecentlyViewed.prototype.remove = function (handle) {
    var self = this;
    this.generation += 1;
    this.history = this.history.filter(function (item) { return item.handle !== handle; });
    delete this.cards[handle];
    writeHistory(this.key, this.history);
    writeCards(this.key, this.cards);
    this.section.removeAttribute('data-integy-v520-recent-loading');
    this.render();
    instances.forEach(function (instance) { if (instance !== self && instance.key === self.key) instance.refreshFromStorage(); });
  };

  RecentlyViewed.prototype.clear = function () {
    var self = this;
    this.generation += 1;
    try { localStorage.removeItem(this.key); } catch (error) {}
    try { sessionStorage.removeItem(this.key); } catch (error) {}
    this.history = [];
    this.cards = { cardSettings: this.cardSettings };
    this.section.removeAttribute('data-integy-v520-recent-loading');
    this.render();
    instances.forEach(function (instance) { if (instance !== self && instance.key === self.key) instance.refreshFromStorage(); });
  };

  RecentlyViewed.prototype.refreshFromStorage = function () {
    this.generation += 1;
    this.history = trimHistory(readHistory(this.key));
    this.cards = readCards(this.key);
    this.backgroundStarted = false;
    this.hydrate();
  };

  RecentlyViewed.prototype.onClick = function (event) {
    var more = event.target.closest && event.target.closest('[data-integy-v520-recent-more]');
    if (more && this.section.contains(more)) { event.preventDefault(); this.expanded = !this.expanded; this.render(); return; }
    var remove = event.target.closest && event.target.closest('[data-remove-recently-viewed]');
    if (remove && this.section.contains(remove)) {
      event.preventDefault(); event.stopPropagation();
      var handleNode = remove.closest('[data-product-handle]');
      if (handleNode) this.remove(String(handleNode.getAttribute('data-product-handle') || ''));
      return;
    }
    var clear = event.target.closest && event.target.closest('[data-clear-recently-viewed]');
    if (clear && this.section.contains(clear)) { event.preventDefault(); event.stopPropagation(); this.clear(); }
  };

  RecentlyViewed.prototype.init = function () {
    this.section.classList.remove('integy-v507-recently-viewed','integy-v514-recently-viewed');
    this.section.classList.add('integy-v520-recently-viewed');
    this.section.setAttribute('data-integy-v520-recent-ready', 'true');
    this.section.addEventListener('click', this.boundClick);
    this.loadState();
    return this.hydrate();
  };

  RecentlyViewed.prototype.destroy = function () {
    this.generation += 1;
    if (this.renderFrame) window.cancelAnimationFrame(this.renderFrame);
    if (this.cacheTimer) window.clearTimeout(this.cacheTimer);
    this.section.removeEventListener('click', this.boundClick);
    this.section.removeAttribute('data-integy-v520-recent-initialized');
  };

  function initializeWithin(scope) {
    all('[data-integy-v520-recent-section]', scope || document).forEach(function (section) {
      if (section.getAttribute('data-integy-v520-recent-initialized') === 'true') return;
      var sectionId = section.getAttribute('data-section-id');
      var script = sectionId ? one('script[data-integy-v520-recent-data][data-section-id="' + sectionId + '"]') : one('script[data-integy-v520-recent-data]', section.parentNode || document);
      var data = readJson(script);
      if (!data || !data.time) {
        section.hidden = true;
        section.classList.add('hide');
        section.setAttribute('aria-hidden', 'true');
        return;
      }
      section.setAttribute('data-integy-v520-recent-initialized', 'true');
      var instance = new RecentlyViewed(section, script, data);
      instances.push(instance);
      instance.init();
    });
  }

  function boot() { root.classList.add('integy-v520-recent-owner'); initializeWithin(document); }

  window.IntegyV520RecentlyViewed = {
    version: 'V520',
    refresh: function (scope) {
      initializeWithin(scope || document);
      instances.forEach(function (instance) { instance.refreshFromStorage(); });
    },
    instances: instances
  };

  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target || document); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.slice().forEach(function (instance) {
      if (instance.section === event.target || (event.target && event.target.contains(instance.section))) {
        instance.destroy();
        var index = instances.indexOf(instance);
        if (index >= 0) instances.splice(index, 1);
      }
    });
  });
  window.addEventListener('pageshow', function () { instances.forEach(function (instance) { instance.refreshFromStorage(); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
